import React from 'react';
import { IconProps } from '../../icons/types';

const UserManagementActiveIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28005 8.74004C11.4064 8.74004 13.1301 7.01634 13.1301 4.89004C13.1301 2.76374 11.4064 1.04004 9.28005 1.04004C7.15376 1.04004 5.43005 2.76374 5.43005 4.89004C5.43005 7.01634 7.15376 8.74004 9.28005 8.74004Z"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9.28005 18.96H1.25005C1.13959 18.96 1.0498 18.8699 1.05244 18.7594C1.15871 14.3024 4.79711 10.73 9.28005 10.73C10.09 10.73 10.88 10.85 11.62 11.07"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18.2702 11.003C17.4942 10.9675 16.7063 11.2445 16.1154 11.8354C15.3162 12.6346 15.0952 13.7916 15.4425 14.7954L11.3623 18.8756C10.8792 19.3586 10.8792 20.1507 11.3623 20.6337C11.8453 21.1167 12.6413 21.1167 13.1243 20.6337L17.2045 16.5535C18.2085 16.9012 19.3651 16.6839 20.1645 15.8845C20.9523 15.0966 21.1828 13.9565 20.8568 12.9634C20.8369 12.9028 20.8018 12.8484 20.7549 12.8052C20.708 12.7621 20.6509 12.7316 20.5889 12.7168C20.5269 12.702 20.4621 12.7033 20.4008 12.7206C20.3394 12.7379 20.2835 12.7706 20.2384 12.8156L19.196 13.858C18.8988 14.1551 18.439 14.1551 18.1419 13.858C17.8448 13.5609 17.8448 13.101 18.1419 12.8039L19.1843 11.7615C19.2293 11.7164 19.262 11.6605 19.2793 11.5991C19.2966 11.5378 19.2979 11.473 19.2831 11.411C19.2682 11.349 19.2378 11.2919 19.1946 11.2449C19.1515 11.198 19.097 11.163 19.0365 11.1431C18.7882 11.0616 18.5289 11.0149 18.2702 11.003ZM18.1341 11.7537L17.6129 12.2749C17.0324 12.8555 17.0324 13.8065 17.6129 14.387C18.1934 14.9675 19.1444 14.9675 19.725 14.387L20.2461 13.8658C20.2449 14.4042 20.0478 14.9432 19.6355 15.3555C18.9917 15.9993 18.0424 16.138 17.2628 15.7834C17.1941 15.7522 17.1176 15.7426 17.0433 15.7558C16.969 15.769 16.9004 15.8044 16.8466 15.8573L12.5953 20.1086C12.3957 20.3082 12.0909 20.3082 11.8912 20.1086C11.6917 19.909 11.6917 19.6042 11.8912 19.4046L16.1426 15.1532C16.1955 15.0995 16.2309 15.0309 16.2441 14.9566C16.2573 14.8823 16.2477 14.8058 16.2165 14.7371C15.8619 13.9575 16.0006 13.0043 16.6444 12.3605C17.0567 11.9482 17.5957 11.7547 18.1341 11.7537Z"
        fill="white"
      />
    </svg>
  );
};

export default UserManagementActiveIcon;
